import { toKebabCase } from '@/utils/case';

export const MINIMUM_LANDING_NAME_LENGTH = 8;

export const getLandingName = (displayName: string): string => {
  const kebab = toKebabCase(displayName);
  const stripped = kebab.replace(/^landing(?:-|$)/, '');
  return `landing-${stripped}`;
};
